import { render } from "./X272.vue?vue&type=template&id=61a3c248"
import script from "./X272.vue?vue&type=script&lang=js"
export * from "./X272.vue?vue&type=script&lang=js"

import "./X272.vue?vue&type=style&index=0&id=61a3c248&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__